import { MsalProvider } from "@azure/msal-react";
import { reactErrorHandler } from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { initAuth } from "~auth/initialization";
import { App } from "~components/App/App";
import { I18nProvider } from "~contexts/I18nContext/I18nContext.tsx";
import { UpdateProvider } from "~contexts/UpdateContext/UpdateContext.tsx";
import { OpenAPI } from "~generated";
import { initMuiX } from "~initializer/mui";
import { initOpenApi } from "~initializer/openapi";
import { initPostHog } from "~initializer/postHog.ts";
import { init as initSentry } from "~initializer/sentry";

import "./assets/scss/index.scss";

initSentry();
initMuiX();

const postHogClient = initPostHog();
const msalInstance = await initAuth(postHogClient);

initOpenApi(msalInstance);

OpenAPI.BASE = "";

const root = createRoot(document.getElementById("root") as HTMLElement, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
});
root.render(
  <StrictMode>
    <PostHogProvider client={postHogClient}>
      <I18nProvider>
        <MsalProvider instance={msalInstance}>
          <UpdateProvider>
            <App />
          </UpdateProvider>
        </MsalProvider>
      </I18nProvider>
    </PostHogProvider>
  </StrictMode>,
);
